import { render, staticRenderFns } from "./telephone-book.vue?vue&type=template&id=6b3b1178&scoped=true"
import script from "./telephone-book.vue?vue&type=script&lang=ts"
export * from "./telephone-book.vue?vue&type=script&lang=ts"
import style0 from "./telephone-book.vue?vue&type=style&index=0&id=6b3b1178&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b1178",
  null
  
)

export default component.exports